import React from "react";

const PrevArrow = (props) =>
{
return(
    <div className="slick-nav prev-arrow" onClick={props.onClick}>
        <i></i> <svg><use xlinkHref="#circle" /></svg>
    </div> 
);

}

export default PrevArrow